import { useEffect } from "react";

const SCRIPT_SRC = "https://reputationhub.site/reputation/assets/review-widget.js";
const WIDGET_SRC = "https://reputationhub.site/reputation/widgets/review_widget/D8zHHsXQdNqiD1R03R0i";

interface ReviewsWidgetProps {
  /** Kept for API compatibility with previous usage; the embed manages its own layout. */
  limit?: number;
  /** Optional ReputationHub widget ID to load a page-specific review widget. */
  widgetId?: string;
}

export function ReviewsWidget({ widgetId }: ReviewsWidgetProps) {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.type = "text/javascript";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  const iframeSrc = widgetId ? `${WIDGET_SRC}?widgetId=${widgetId}` : WIDGET_SRC;

  return (
    <div className="w-full min-h-[620px]">
      <iframe
        className="lc_reviews_widget w-full"
        src={iframeSrc}
        title="Customer reviews for VRP Flooring LLC"
        frameBorder="0"
        scrolling="no"
        loading="lazy"
        style={{ minWidth: "100%", width: "100%", minHeight: "620px" }}
      />
    </div>
  );
}

